{
  "equipYour": "Equip Your",
  "people": "people",
  "students": "students",
  "leaders": "leaders",
  "citizens": "citizens",
  "rebels": "rebels",
  "toLaunchWhatIsNext": "to launch what's next",
  "thePlatformThat": "The platform that lets people ",
  "tackleProblemsThe": "tackle problems the WAY entrepreneurs do",
  "viewProjectsBuilt": "View Projects Built on RebelBase",
  "projectBasedLearning": "project-based learning online",
  "classrooms": "Classrooms",
  "incubators": "Incubators",
  "competitions": "Competitions",
  "alumniNetwork": "Alumni Networks",
  "equipStudentsTo": "Equip students to attack problems and build solutions of their own",
  "enableLearningBy": "Enable learning by doing — with easy-to-use tools",
  "exploreHowRebelbase": "How can RebelBase work for you?",
  "equipYourStudents": "Equip Your Students",
  "prepareStudentsTo": "Prepare students to thrive, as they build skills like creativity, collaboration, and adaptability – earning badges, forging connections and building a portfolio of what they can do.",
  "hostACompetition": "Host A Competition",
  "putOnACompetition": "Put on a competition or demo day that engages alumni and challenges your students to pursue new heights. Enable judges to score projects using in-platform rubrics.",
  "replaceYourTextbook": "Replace Your Textbook",
  "upgradeYourTeaching": "Upgrade your teaching materials with interactive modules created by experts in what it takes to launch what’s next: from analyzing systems to pitching ideas.",
  "runYourCourse": "Run Your Course",
  "whetherYoureRunning": "Whether you're running a course or a series of workshops, set schedule, manage pre-work, facilitate collaboration, and evaluate results.",
  "sparkCollaboration": "Spark Collaboration",
  "createAnOnline": "Create an online ecosystem of students, instructors, and mentors, as they collaborate, answer questions, iterate, and exchange feedback and resources.",
  "rebelBaseBuilds": "RebelBase builds the skills and mindset today's talent needs",
  "rebelBaseIsAn": "RebelBase is an online platform that enables you — if you have an idea of something that you want to do — that gives you a consistent, coherent way of walking through: what will it take to make this real? And what impact will it have in the world? How much money do I have to raise to make this come into being? Who Are my team members? What will it take to frame up this idea, and make it real?",
  "hunterLovins": "Hunter Lovins, President and Founder",
  "ofNaturalCapital": "Natural Capital Solutions",
  "rebelBasesLibraryOf": "RebelBase's library of interactive builders lets you decide what your users build",
  "stepByStep": "Step-by-Step Modules",
  "rebelBasesIntutiveWorksheets": "RebelBase's intutive worksheets and examples demystify concepts as you go, so users can apply them as they build their projects.",
  "rebelBaseHelpedReshape": "RebelBase helped reshape the way I think when it comes to attacking a problem. I've never started a business before, and … it showed me how to look at a situation in a strategic way to be able to shape it into the solution that I want it to be.",
  "miciiRay": "Micii Ray, Founder",
  "leapForward": "Leap Forward at Riseboro Community Partnerships",
  "activateThoseWho": "Activate Those Who Can Help",
  "connectTheAssets": "Connect the assets in your community — alumni, industry experts, and supporters — to your budding problem solvers using a structured project platform.",
  "whatRebelBasedoes": "What RebelBase does is it takes you through the rigorous framework that you need to turn an idea into something that has bones and can be evaluated as a potential business. There's nothing like it in the world.",
  "ebanGoodstein": "Eban Goodstein, Director",
  "bardCollege": "Graduate Programs in Sustainability, Bard College",
  "driveFeedbackAnd": "Drive Feedback and Participation",
  "thePlatformLets": "The platform lets peers, experts, and supporters weigh in on each project module with questions, resources, and critique.",
  "theGroupElement": "The group element and the collaboration that took place in RebelBase helped me realize this can be a formula: anyone can do it with some support.",
  "caitlinODonnel": "Caitlin O'Donnell, Participant",
  "openSocietyUniversity": "Open Society University Network",
  "usedByEducationaLeaders": "Used by educational leaders globally",
  "masteryOfThe": "Mastery of the entrepreneurial method will become a fundamental literacy not only for business degrees, but across disciplines.",
  "alejandroCrawford": "Alejandro Crawford, CEO",
  "rebelBaseAsQuoted": "RebelBase, as quoted in Tech CEO Blog Nation",
  "ofUsersBuilt": "of users built entrepreneurial skills",
  "ofUsersReported": "of users reported high confidence in launching new solutions",
  "ofUsersSay": "of users say RebelBase helped them learn to present in front of a group",
  "readFullReport": "Read the full report",
  "countries": "Countries",
  "users": "Users",
  "projects": "Projects",
  "weHelpLibraries": "We help libraries in the developing world to preserve and expand their access. If I had had access to RebelBase at the beginning, I believe I would have made less mistakes, seen the pitfalls, and launched sooner.",
  "video": "[video]",
  "lennonMazonde": "Lennon Mazonde, Winner of the Disrupt to Sustain Competition on RebelBase",
  "graduateOfSocial": "Graduate of social enterprise program at ASSETS Lancaster",
  "readyToBe": "Ready to be a FEARLESS Innovation Leader?",
  "rebelBaseIsMore": "RebelBase is more than just software — when you use it, you get a playbook for developing result-driven entrepreneurs.",
  "RequestaDemo": "Request a Demo and Free Consultation",
  "itsModular": "It's modular — you set the schedule",
  "ideate": "Ideate",
  "validate": "Validate",
  "launch": "Launch",
  "scale": "Scale",
  "impact": "Impact",
  "finance": "Finance"
}
